module.exports = __webpack_public_path__ + "img/album01_16.945eccb2.jpg";